import { NAV_DRAWER_WIDTH } from "../../../../components/navDrawer/constants";

export type LayoutToken = keyof typeof layoutTokens;

export const layoutTokens = {
  "$responsive-topbar-height": "var(--topbar-height)",
  "$nav-drawer-width": NAV_DRAWER_WIDTH,
};
